export default __webpack_public_path__ + "static/media/036-conch shell.522ff945.svg";